<template>
  <v-container>
    <Filters :items="listMaster" :numberLinesOptions="numberLinesOptions" />
    <DataTable
      :loading="loading"
      :items="listFiltered"
      :items-per-page.sync="itemsPerPage"
      @refresh="findAllIntegrationLogs"
    />
  </v-container>
</template>

<script>
import Service from '../../../../services/MonitoringCockpitService'
import Filters from './Filters.vue'
import DataTable from './DataTable.vue'

export default {
  name: 'AllIntegrationLogs',

  components: { Filters, DataTable },

  data: () => ({
    loading: true,
    refreshItemsPerPage: true,
    refreshListFiltered: true,
    listMaster: [],
    numberLinesOptions: ['10', '100', '200', '300', '400', '500', '600', '700', '800', '900', '10000']
  }),

  created () { this.findAllIntegrationLogs() },

  computed: {
    canFindAllIntegrationLogs () {
      const { processType, integrationID, startDate, endDate } = this.$route.query
      return processType && integrationID && startDate && endDate
    },
    limitRows () {
      const { numberLinesFilter } = this.$route.query
      const numberLines = this.numberLinesOptions.includes(numberLinesFilter) ? numberLinesFilter : '10'
      return parseInt(numberLines)
    },
    listFiltered () {
      const { refreshListFiltered } = this // eslint-disable-line no-unused-vars
      const { monitoringIDFilter, statusFilter } = this.$route.query
      return this.listMaster
        .filter(i => !monitoringIDFilter || i.monitoringID === monitoringIDFilter)
        .filter(i => !statusFilter || i.status === statusFilter)
    },
    itemsPerPage: {
      get () {
        const { refreshItemsPerPage } = this // eslint-disable-line no-unused-vars
        return this.$cookies.isKey('monitoring_all-integration-logs_per_page') ? parseInt(this.$cookies.get('monitoring_all-integration-logs_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('monitoring_all-integration-logs_per_page', value)
        this.refreshItemsPerPage = !this.refreshItemsPerPage // It's to force a recompute of 'itemsPerPage' !
      }
    }
  },

  methods: {
    findAllIntegrationLogs () {
      if (!this.canFindAllIntegrationLogs) return console.error(this.$t('warnings.error.not_enough_data'))
      const { processType, integrationID, startDate, endDate } = this.$route.query
      this.loading = true

      if (!endDate) return

      Service.allIntegrationLogs(processType, integrationID, startDate, endDate, this.limitRows)
        .then(response => { this.listMaster = response.data })
        .catch(error => console.error(this.$t('warnings.error.occurred'), error))
        .finally(() => { this.loading = false })
    }
  },

  watch: {
    '$route.query.numberLinesFilter': 'findAllIntegrationLogs',
    '$route.query.endDate': 'findAllIntegrationLogs',
    '$route.query' () { this.refreshListFiltered = !this.refreshListFiltered }
  }
}
</script>
